var map = {
	"./logo_email.svg": "6df1",
	"./logo_skype.svg": "f394",
	"./logo_telegram.svg": "ea99",
	"./logo_viber.svg": "7206",
	"./logo_whatsApp.svg": "8054"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13e3";